import React from "react";
import { NavLink } from "react-router-dom";
import { compose } from "recompose";

export const ReportsListing = compose()((props) => {
  let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
  return (
    <>
      <div className="margin-btm-50">
      <NavLink
              className="btn auxo-primary-btn create-geofence-btn"
              activeClassName="active"
              to="/scheduleReport"
            >
              Schedule Report
            </NavLink>
       
      </div>
      <ul className="reports-list m-t-100">
        {/*     
        <li>
          <span>
            <h4>Alarm Report</h4>
            <p>
              Summary of the alarm notifications received by the user, including
              the alarm name, unit name, alarm type and alarm contents, etc
            </p>
          </span>
          <span className="select-report">
            <a onClick={() => props.selectType("alarmReport")}>select</a>
          </span>
        </li> */}


        <li>
          <span>
            <h4>Distance Report</h4>
            <p>
              Total distance traveled in a time duration.
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/distanceReport"
            >
              Select
            </NavLink>
            {/* <a onClick={() => props.selectType("alarmReport")}></a> */}
          </span>
        </li>

        <li>
          <span>
            <h4>Temperature Report</h4>
            <p>
              Temperature Report
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/temperatureReport"
            >
              Select
            </NavLink>
          </span>
        </li>

        <li>
          <span>
            <h4>Observation Report</h4>
            <p>
              Observation Report
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/observationReport"
            >
              Select
            </NavLink>
          </span>
        </li>
        
        {companyInfo.companyId === "686f9bab6a94aa3a86c61f35" && (
          <>
              <li>
          <span>
            <h4>Device Detail Report</h4>
            <p>
              Device detail report
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/deviceDetailReport"
            >
              Select
            </NavLink>
          </span>
        </li>
         <li>
          <span>
            <h4>Data Dump Report</h4>
            <p>
              data dump report
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/dataDumpReport"
            >
              Select
            </NavLink>
          </span>
        </li>
          <li>
          <span>
            <h4>Day Wise Dump Report</h4>
            <p>
              day wise data dump 
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/dayWiseReport"
            >
              Select
            </NavLink>
          </span>
        </li>
        <li>
          <span>
            <h4>Power Report</h4>
            <p>
              Power Report
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/powerReport"
            >
              Select
            </NavLink>
          </span>
        </li>
         <li>
      <span>
        <h4>TroubleShoot Report</h4>
        <p>TroubleShoot Report</p>
      </span>
      <span className="select-report">
        <NavLink
          className="nav-link"
          activeClassName="active"
          to="/troubleshootReport"
        >
          Select
        </NavLink>
      </span>
    </li>
          </>
        )}

        {/* 69a684ca6261b57e2804a79b */}
        {
  companyInfo.companyId !== "69a684ca6261b57e2804a79b"  && (
    <li>
      <span>
        <h4>TroubleShoot Report</h4>
        <p>TroubleShoot Report</p>
      </span>
      <span className="select-report">
        <NavLink
          className="nav-link"
          activeClassName="active"
          to="/troubleshootReport"
        >
          Select
        </NavLink>
      </span>
    </li>
  )
}


        <li>
          <span>
            <h4>Event Report</h4>
            <p>
              Event Report
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/eventReport"
            >
              Select
            </NavLink>
          </span>
        </li>
{/* {   companyInfo.companyId !== "69a684ca6261b57e2804a79b" &&     <li>
          <span>
            <h4>Power Report</h4>
            <p>
              Power Report
            </p>
          </span>
          <span className="select-report">
            <NavLink
              className="nav-link "
              activeClassName="active"
              to="/powerReport"
            >
              Select
            </NavLink>
          </span>
        </li>} */}


      </ul>
    </>
  );
});
